import React, { useId } from "react";
import { cn } from "../../lib/cn";
import { Card } from "./Card";

/** Trust story cards — aligns with Home / About copy. */
const TRUST_POINTS = [
  {
    title: "30+ years of advanced automotive repair",
    body: "Dealer-level diagnostics and complex repairs from a Temecula independent shop—straight answers without dealership markup.",
  },
  {
    title: "Licensed smog & mechanical repair",
    body: "Star-certified emissions testing plus full mechanical service in one location—from European imports to daily drivers.",
  },
  {
    title: "European vehicle & Land Rover specialists",
    body: "Experienced with BMW, Mercedes-Benz, Audi, Jaguar, Land Rover, and Range Rover, with tooling and training to match.",
  },
  {
    title: "Transparent estimates & clear communication",
    body: "We explain what failed, what it takes to fix it, and what it costs—no vague promises or surprise add-ons.",
  },
];

/** Credential labels align with the About page. */
const CERTIFICATIONS = [
  "ASE Master Technician",
  "Licensed Smog & Repair Technician",
  "Factory trained by Jaguar & Land Rover",
  "Electric Vehicle approved",
];

export default function TrustBadges({ className, tone = "light" }) {
  const light = tone === "light";
  const headingId = useId();
  const certsId = useId();

  return (
    <section
      className={cn("", className)}
      aria-labelledby={headingId}
    >
      <div
        className={cn(
          light && "border-l-4 border-slate-300 pl-4 sm:pl-5",
        )}
      >
      <h2
        id={headingId}
        className={cn(
          "text-lg font-semibold tracking-tight sm:text-xl",
          light ? "text-navy-900" : "text-white",
        )}
      >
        Why owners choose our shop
      </h2>
      <ul className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {TRUST_POINTS.map((item) => (
          <Card
            key={item.title}
            as="li"
            interactive
            padding="md"
            className="flex flex-col"
          >
            <p className="text-sm font-semibold text-[var(--color-primary)]">
              {item.title}
            </p>
            <p className="mt-2 text-xs leading-relaxed text-slate-600 sm:text-[13px]">
              {item.body}
            </p>
          </Card>
        ))}
      </ul>
      </div>

      <div
        className={cn(
          "mt-8 pt-8",
          light ? "border-t border-slate-200" : "border-t border-white/[0.06]",
        )}
      >
        <h3
          id={certsId}
          className={cn(
            "text-xs font-semibold uppercase tracking-[0.18em]",
            light ? "text-slate-500" : "text-slate-400",
          )}
        >
          Certifications
        </h3>
        <ul
          className="mt-4 flex flex-wrap gap-2"
          aria-labelledby={certsId}
        >
          {CERTIFICATIONS.map((label) => (
            <li key={label}>
              <span className="inline-flex max-w-full rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-left text-xs font-medium leading-snug text-slate-700 shadow-sm transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:border-teal-600 hover:shadow-md sm:text-sm">
                {label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
